import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../../classes/services/notification.service';
import { ExceptionManager } from './exceptionManager';
import { SpinnerService } from '../services/spinner.service';

@Injectable()
export class ExceptionHandler implements ErrorHandler {
    constructor(
        private notificationService: NotificationService,
        private exceptionManager: ExceptionManager,
        private spinnerService: SpinnerService,
    ) {}

    handleError(error: Error | HttpErrorResponse) {
        if (error instanceof HttpErrorResponse) {
            // Server or connection error happened
            this.exceptionManager.handleError(error);
        } else {
            this.notificationService.addErrorMessage(error.message);
        }
        if (error.name === 'TimeoutError') {
            this.spinnerService.hideSpinner();
        }

        console.error('It happens: ', error);
    }

    handleError400(error: any) {
        if (error?.error) {
            if (error.error instanceof Array) {
                for (let item of error.error) {
                    if (item.key != null) {
                        // this.setCustomError(item.key, item.field, form);
                    } else {
                        this.notificationService.addErrorMessage(item.message);
                    }
                }
            } else {
                this.notificationService.addErrorMessage(error.error?.error);
            }
        } else {
            this.notificationService.addErrorMessage(`${error?.status || ''} - ${error?.message}`);
        }
    }
}
